/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Flowmaxsetpoint2Inputs */



/**
* | output |
* | --- |
* | "Maximum flow setpoint" |
*
* @param {Ahu_History_Key_Flowmaxsetpoint2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_flowmaxsetpoint2 = /** @type {((inputs?: Ahu_History_Key_Flowmaxsetpoint2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Flowmaxsetpoint2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Maximum flow setpoint")
	return /** @type {LocalizedString} */ ("Consigne maximum de débit")
});
export { ahu_history_key_flowmaxsetpoint2 as "ahu_history_key_flowMaxSetpoint" }